import Cookies from 'js-cookie';

type CookieArgs = Parameters<typeof Cookies.set>;

export function setClientCookie(name: string, value: string, options?: CookieArgs[2]): void {
  Cookies.set(name, value, options);
}

export function getClientCookie(name: string): string | undefined {
  return Cookies.get(name);
}

export function deleteClientCookie(name: string): void {
  Cookies.remove(name);
}
